// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Stack,
  Heading,
  Divider,
  Select,
  Spacer,
  FormHelperText,
  Text,
  useColorMode,
  FormControl,
  FormLabel,
  Input,
  useColorModeValue,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Image,
  Link,
  Textarea,
  Tabs, TabList, TabPanels, Tab, TabPanel
} from "@chakra-ui/react";
import config from "config/index";
import Card from "components/Card/Card.js";
import IconBox from "components/Icons/IconBox";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { toast } from 'react-toastify';
import NiceButton from "components/NiceButton/NiceButton.js";

import React from "react";
import { getGlobal } from "config/global";
import { RiPlantLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import allFiles from "api/filemanager/all-files";
import classic from "assets/img/classic.jpg";
import classicFullPage from "assets/img/classic-full-page.jpg";
import { HSeparator } from "components/Separator/Separator";
import allLanding from "api/landing/all-landing";
import editLanding from "api/landing/edit-landing";

function Landing() {
  const { address, tourname } = useParams()
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const iconBlue = useColorModeValue("gray.100", "navy.700");

  const borderColor = useColorModeValue("#dee2e6", "#374062");
  const { colorMode } = useColorMode();
  const [images, setImages] = useState("");
  const [landing, setLanding] = useState({})
  const [isChangeTemplateLoading, setIsChangeTemplateLoading] = useState(-1)
  const [isSaveLoading, setIsSaveLoading] = useState(false)

  const [data, setData] = useState({})
  const [reload, setReload] = useState(false)

  const [sizeOfStatistic, setSizeOfStatistic] = useState(5)
  function addStatistic() {
    if (sizeOfStatistic < 6)
      setSizeOfStatistic(sizeOfStatistic + 1)
  }
  function removeStatistic() {
    if (sizeOfStatistic > 3)
      setSizeOfStatistic(sizeOfStatistic - 1)
  }

  const [sizeOfServices, setSizeOfServices] = useState(3)
  function addService() {
    if (sizeOfServices < 6)
      setSizeOfServices(sizeOfServices + 1)
  }
  function removeService() {
    if (sizeOfServices > 3)
      setSizeOfServices(sizeOfServices - 1)
  }
  let icons = [
    ["", ""],
    ["copy", "کپی"],
    ["code", "کد"],
    ["gem", "الماس"],
    ["bell", "زنگ"],
    ["award", "مدال"],
    ["bolt", "رعد"],
    ["bomb", "بمب"],
    ["book", "کتاب"],
    ["calculator", "ماشین حساب"],
    ["camera", "دوربین"],
    ["folder-open", "فولدر باز"],
    ["signal", "سیگنال"],
    ["laptop", "لپتاپ"],
    ["code-branch", "شاخه کد"],
  ]
  let me = getGlobal("me")
  useEffect(() => {
    allFiles("image").then((result) => {
      let images = result.data
      images.unshift({
        path: "default",
        filename: "پیش فرض"
      })
      setImages(images)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allLanding(address).then((result) => {
      result = result.data
      setLanding(result)
      let d = data;
      d["landing-title"] = result.title
      d["landing-description"] = result.description
      d["logo-image"] = result.logo
      d["cover-image"] = result.cover
      d["aboutus-text"] = result.aboutus.text
      d["aboutus-image"] = result.aboutus.image
      d["website"] = result.website
      d["summary"] = result.contactus.summary
      d["address"] = result.contactus.address
      d["tel"] = result.contactus.tel
      d["email"] = result.contactus.email
      d["facebook"] = result.contactus.facebook
      d["github"] = result.contactus.github
      d["dribbble"] = result.contactus.dribbble
      d["twitter"] = result.contactus.twitter
      d["instagram"] = result.contactus.instagram
      result.services.forEach((element, index) => {
        d["service-title" + (index + 1)] = element.title
        d["service-icon" + (index + 1)] = element.icon
        d["service-description" + (index + 1)] = element.description
      });
      setSizeOfServices(result.services.length)

      d["statistic-description"] = result.statistics.description
      d["statistic-more-description"] = result.statistics.more
      d["statistic-website"] = result.statistics.website
      result.statistics.items.forEach((element, index) => {
        d["statistic-title" + (index + 1)] = element.title
        d["statistic-icon" + (index + 1)] = element.icon
        d["statistic-number" + (index + 1)] = element.number
      });
      setSizeOfStatistic(result.statistics.items.length)
      setData(data);
      setReload(true)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [reload])
  function handleFormChange(event) {
    let d = { ...data }
    d[event.target.name] = event.target.value;
    setData(d);
  }
  function save() {
    setIsSaveLoading(true)
    let d = {
      title: data["landing-title"],
      description: data["landing-description"],
      logo: data["logo-image"],
      cover: data["cover-image"],
      aboutus: {
        text: data["aboutus-text"],
        image: data["aboutus-image"]
      },
      website: data["website"],
      services: [],
      statistics: {
        description: data["statistic-description"],
        more: data["statistic-more-description"],
        website: data["statistic-website"],
        items: [

        ]
      }
    }
    for (let i = 0; i < sizeOfServices; i++) {
      d.services.push({
        title: data["service-title" + (i + 1)],
        icon: data["service-icon" + (i + 1)],
        description: data["service-description" + (i + 1)]
      })
    }
    for (let i = 0; i < sizeOfStatistic; i++) {
      d.statistics.items.push({
        title: data["statistic-title" + (i + 1)],
        icon: data["statistic-icon" + (i + 1)],
        number: data["statistic-number" + (i + 1)],
      })
    }
    editLanding(address, d).then((result) => {
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    setIsSaveLoading(false)
    })
  }
  function changeTemplate(template) {
    console.log(template)
    if (template == 0 || template == 1) {
      setIsChangeTemplateLoading(template)
      editLanding(address, {
        template
      }).then((result) => {
        setReload(!reload)
        return toast.success("با موفقیت انجام شد.", {
          position: "bottom-right"
        })
      }).catch((err) => {
        console.error(err)
        if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("خطایی رخ داده است.", {
            position: "bottom-right"
          })
      }).finally(() => {
        setIsChangeTemplateLoading(-1)
      })
    }
  }
  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <Grid templateColumns={{ sm: "1fr", lg: "1fr 1fr" }} templateRows='1fr'>
        <Box>
          <Card p='16px'>
            <CardHeader>
              <Flex justify='space-between' align='center' mb='1rem' w='100%'>
                <Text fontSize='md' color={textColor} fontWeight='bold'>
                  صفحه فرود نمایشگاه {tourname}
                </Text>
                <Box mt={{ sm: "30px", md: "0px" }}>
                  {
                    (landing.active) ? <Button fontSize='xs' onClick={() => {

                      window.open(config.host + "/landing/" + address, '_blank', 'noopener,noreferrer');
                    }}
                    >
                      مشاهده لندینگ
                    </Button> : ""
                  }
                </Box>
              </Flex>
            </CardHeader>
            <CardBody>
              <Tabs>
                <TabList>
                  <Tab padding={{ sm: "0px", md: "10px" }} style={{ "box-shadow": "none" }} fontSize={{ sm: "xs", md: "sm" }}>سربرگ</Tab>
                  <Tab padding={{ sm: "0px", md: "10px" }} style={{ "box-shadow": "none" }} fontSize={{ sm: "xs", md: "sm" }}>درباره ما</Tab>
                  <Tab padding={{ sm: "0px", md: "10px" }} style={{ "box-shadow": "none" }} fontSize={{ sm: "xs", md: "sm" }}>ارتباط با ما</Tab>
                  <Tab padding={{ sm: "0px", md: "10px" }} style={{ "box-shadow": "none" }} fontSize={{ sm: "xs", md: "sm" }}>خدمات و محصولات</Tab>
                  <Tab padding={{ sm: "0px", md: "10px" }} style={{ "box-shadow": "none" }} fontSize={{ sm: "xs", md: "sm" }}>آمار و اطلاعات</Tab>
                </TabList>
                <TabPanels mt="10px">
                  <TabPanel>
                    <Grid>
                      <Flex>
                        <FormControl w='100%' ml="5">
                          <FormLabel fontSize="xs" >عنوان صفحه</FormLabel>
                          <Input name="landing-title" fontSize="xs" placeholder={"عنوان"} value={data && data["landing-title"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs" >توضیح کوتاه</FormLabel>
                          <Input name="landing-description" fontSize="xs" placeholder={"توضیحات"} value={data && data["landing-description"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex>
                        <FormControl mt={"20px"}>
                          <FormLabel fontSize="xs" >لوگو</FormLabel>
                          <Select name="logo-image" w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs"
                            onChange={event => handleFormChange(event)} >
                            {images && images.map((row, idx) => {
                              return (
                                <option selected={data && data["logo-image"] == row.path.replace("upload/user/", "/assets/users/")} dir={"rtl"} value={row.path.replace("upload/user/", "/assets/users/")}>{row.filename}</option>
                              );
                            })}
                          </Select>
                          <FormHelperText fontSize={"xs"}>جهت آپلود فایل جدید از طریق <Link color={colorMode == "dark" ? "white" : "black"} target="_blank" href='/admin/files'>فایل‌ها</Link> اقدام کنید.</FormHelperText>
                        </FormControl>
                      </Flex>
                      <Flex>
                        <FormControl mt={"20px"}>
                          <FormLabel fontSize="xs" >کاور</FormLabel>
                          <Select name="cover-image" w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs"
                            onChange={event => handleFormChange(event)} >
                            {images && images.map((row, idx) => {
                              return (
                                <option selected={data && data["cover-image"] == row.path.replace("upload/user/", "/assets/users/")} dir={"rtl"} value={row.path.replace("upload/user/", "/assets/users/")}>{row.filename}</option>
                              );
                            })}
                          </Select>
                          <FormHelperText fontSize={"xs"}>جهت آپلود فایل جدید از طریق <Link color={colorMode == "dark" ? "white" : "black"} target="_blank" href='/admin/files'>فایل‌ها</Link> اقدام کنید.</FormHelperText>
                        </FormControl>
                      </Flex>
                      
                    </Grid>
                  </TabPanel>
                  <TabPanel>
                    <Grid>
                    <FormControl w='100%'>
                      <FormLabel fontSize="xs" >وب سایت</FormLabel>
                      <Input name="website" dir="ltr" fontSize="xs" placeholder={"وب سایت"} value={data && data["website"]} onChange={event => handleFormChange(event)} />
                    </FormControl>
                    <FormControl w='100%' mt="20px" ml="5">
                      <FormLabel fontSize="xs" >توضیحات درباره ما</FormLabel>
                      <Textarea name="aboutus-text" h="auto" autoGrow={10} rows={5} height="auto" fontSize="xs" placeholder={"متنی برای درباره ما"} value={data && data["aboutus-text"]} onChange={event => handleFormChange(event)} />
                    </FormControl>
                    <Flex>
                      <FormControl mt={"20px"}>
                        <FormLabel fontSize="xs" >تصویر درباره ما</FormLabel>
                        <Select name="aboutus-image" w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs"
                          onChange={event => handleFormChange(event)}>
                          {images && images.map((row, idx) => {
                            return (
                              <option selected={data && data["aboutus-image"] == row.path.replace("upload/user/", "/assets/users/")} dir={"rtl"} value={row.path.replace("upload/user/", "/assets/users/")}>{row.filename}</option>
                            );
                          })}
                        </Select>
                        <FormHelperText fontSize={"xs"}>جهت آپلود فایل جدید از طریق <Link color={colorMode == "dark" ? "white" : "black"} target="_blank" href='/admin/files'>فایل‌ها</Link> اقدام کنید.</FormHelperText>
                      </FormControl>
                    </Flex>
                      </Grid>
                  </TabPanel>
                  <TabPanel>
                    <Grid>
                      <Flex>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs" >توضیحات خلاصه</FormLabel>
                          <Textarea name="summary" h="auto" autoGrow={5} fontSize="xs" placeholder={"متن توضیحات خلاصه"} value={data && data["summary"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex>
                        <FormControl w='100%' mt="20px">
                          <FormLabel fontSize="xs">آدرس</FormLabel>
                          <Input name="address" fontSize="xs" placeholder={"آدرس"} value={data && data["address"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex w='100%' mt="20px">
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">تلفن</FormLabel>
                          <Input dir="ltr" name="tel" fontSize="xs" placeholder={"شماره تلفن"} value={data && data["tel"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex w='100%' mt="20px">
                        <FormControl w='100%' ml="5">
                          <FormLabel fontSize="xs">ایمیل</FormLabel>
                          <Input dir="ltr" name="email" fontSize="xs" placeholder={""} value={data && data["email"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">twitter</FormLabel>
                          <Input dir="ltr" name="twitter" fontSize="xs" placeholder={"https://twitter.com"} value={data && data["twitter"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex w='100%' mt="20px">
                        <FormControl w='100%' ml="5">
                          <FormLabel fontSize="xs">instagram</FormLabel>
                          <Input dir="ltr" name="instagram" fontSize="xs" placeholder={"https://instagram.com"} value={data && data["instagram"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">facebook</FormLabel>
                          <Input dir="ltr" name="facebook" fontSize="xs" placeholder={"https://facebook.com"} value={data && data["facebook"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex w='100%' mt="20px">
                        <FormControl w='100%' ml="5">
                          <FormLabel fontSize="xs">dribbble</FormLabel>
                          <Input dir="ltr" name="dribbble" fontSize="xs" placeholder={"https://dribbble.com"} value={data && data["dribbble"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">github</FormLabel>
                          <Input dir="ltr" name="github" fontSize="xs" placeholder={"https://github.com"} value={data && data["github"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      </Grid>
                  </TabPanel>
                  <TabPanel>
                    <Grid>
                      {[...Array(sizeOfServices)].map((item, index) => {
                        return <Grid><Flex w='100%' mt={index == 0 ? "0px" : "48px"}>
                          <FormControl w='100%' ml="5">
                            <FormLabel fontSize="xs">عنوان #{index + 1}</FormLabel>
                            <Input name={"service-title" + (index + 1)} fontSize="xs" placeholder={"عنوان #" + (index + 1)} value={data && data["service-title" + (index + 1)]} onChange={event => handleFormChange(event)} />
                          </FormControl>
                          <FormControl w='100%'>
                            <FormLabel fontSize="xs" >آیکون #{index + 1}</FormLabel>
                            <Select name={"service-icon" + (index + 1)} w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs"
                              onChange={event => handleFormChange(event)}>
                              {icons && icons.map((row, idx) => {
                                return (
                                  <option selected={data["service-icon" + (index + 1)] == row[0]} dir={"rtl"} value={row[0]}>{row[1]}</option>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Flex>
                          <Flex>
                            <FormControl w='100%' mt="20px">
                              <FormLabel fontSize="xs" >توضیحات #{index + 1}</FormLabel>
                              <Textarea name={"service-description" + (index + 1)} h="auto" autoGrow={5} fontSize="xs" placeholder={"توضیحات #" + (index + 1)} value={data && data["service-description" + (index + 1)]} onChange={event => handleFormChange(event)} />
                            </FormControl>
                          </Flex></Grid>
                      })
                      }


                      <Flex mt={"20px"} w={"100%"}>
                        <Button hidden={sizeOfServices > 5} fontSize='xs' ml="10px" onClick={addService}>
                          +
                        </Button>
                        <Button hidden={sizeOfServices < 4} fontSize='xs' onClick={removeService}>
                          -
                        </Button>
                      </Flex>
                    </Grid>
                  </TabPanel>
                  <TabPanel>
                    <Grid>
                      <Flex w='100%'>
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">توضیحات</FormLabel>
                          <Textarea name="statistic-description" h="auto" autoGrow={5} rows={10} height={"auto"} fontSize="xs" placeholder={"توضیحات"} value={data && data["statistic-description"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex w='100%' mt="20px">
                        <FormControl w='100%'>
                          <FormLabel fontSize="xs">ادامه توضیحات</FormLabel>
                          <Textarea name="statistic-more-description" h="auto" autoGrow={5} rows={15} height={"auto"} fontSize="xs" placeholder={"ادامه توضیحات"} value={data && data["statistic-more-description"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>
                      <Flex>
                        <FormControl w='100%' mt="20px">
                          <FormLabel fontSize="xs" >وبسایت اطلاعات بیشتر</FormLabel>
                          <Input dir="ltr" name="statistic-website" fontSize="xs" placeholder={"وبسایت اطلاعات بیشتر"} value={data && data["statistic-website"]} onChange={event => handleFormChange(event)} />
                        </FormControl>
                      </Flex>

                      {[...Array(sizeOfStatistic)].map((item, index) => {
                        return <Grid>
                          <Flex>
                            <FormControl w='100%' mt="48px">
                              <FormLabel fontSize="xs">عنوان #{index + 1}</FormLabel>
                              <Input name={"statistic-title" + (index + 1)} fontSize="xs" placeholder={"عنوان"} value={data && data["statistic-title" + (index + 1)]} onChange={event => handleFormChange(event)} />
                            </FormControl>

                          </Flex>
                          <Flex>
                            <FormControl w='100%' mt="20px" ml="10px">
                              <FormLabel fontSize="xs" >آیکون #{index + 1}</FormLabel>
                              <Select name={"statistic-icon" + (index + 1)} w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs"
                                onChange={event => handleFormChange(event)}>
                                {icons && icons.map((row, idx) => {
                                  return (
                                    <option selected={data["statistic-icon" + (index + 1)] == row[0]} dir={"rtl"} value={row[0]}>{row[1]}</option>
                                  );
                                })}

                              </Select>
                            </FormControl>
                            <FormControl w='100%' mt="20px">
                              <FormLabel fontSize="xs">شمارنده #{index + 1}</FormLabel>
                              <Input dir="ltr" type="number" name={"statistic-number" + (index + 1)} fontSize="xs" placeholder={"شمارنده"} value={data && data["statistic-number" + (index + 1)]} onChange={event => handleFormChange(event)} />
                            </FormControl>
                          </Flex>
                        </Grid>
                      })}
                      <Flex mt={"20px"} w={"100%"}>
                        <Button hidden={sizeOfStatistic > 4} fontSize='xs' ml="10px" onClick={addStatistic}>
                          +
                        </Button>
                        <Button hidden={sizeOfStatistic < 4} fontSize='xs' onClick={removeStatistic}>
                          -
                        </Button>
                      </Flex>
                   
                    </Grid>
                  </TabPanel>
                </TabPanels>
              </Tabs>
              <Flex mt={"20px"} id="save-input">
                        <Spacer />
                        <NiceButton
                      color={colorMode === "dark" ? "white" : "black"}
                      isLoading={isSaveLoading}
                          fontSize='xs' onClick={save}>
                          ذخیره
                        </NiceButton>
                      </Flex>
            </CardBody>
          </Card>
        </Box>
        <Box>
          <Card p='22px'
            my={{ sm: "24px", lg: "0px" }}
            ms={{ sm: "0px", lg: "12px" }}>
            <CardHeader>
              <Flex justify='space-between' align='center' mb='1rem' w='100%'>
                <Text fontSize='md' color={textColor} fontWeight='bold'>
                  انتخاب قالب
                </Text>
              </Flex>
            </CardHeader>
            <CardBody>

              <Grid templateColumns={{ sm: "1fr", lg: "1fr 1fr" }} templateRows='1fr' gap='20px'>
                {[
                  {
                    code: 0,
                    image: <Image
                      src={classic}
                      alt='classic'
                      borderRadius='lg'
                    />
                  },
                  {
                    code: 1,
                    image: <Image
                      src={classicFullPage}
                      alt='classicFullPage'
                      borderRadius='lg'
                    />
                  }


                ].map((item) => {
                  return <Box w='100%' p={4} border={"1px solid " + borderColor} borderRadius={"10px"} >
                    {item.image}
                    <Stack mt='6' spacing='3'>
                      <NiceButton
                        isLoading={isChangeTemplateLoading == item.code}
                      color={colorMode === "dark" ? "white" : "black"}
                      onClick={() => { changeTemplate(item.code) }} w="100%" fontSize='xs' style={{ "box-shadow": "none" }} disabled={landing.template == item.code}>
                        فعالسازی
                      </NiceButton>
                    </Stack>
                  </Box>
                })}
              </Grid>
            </CardBody>
          </Card>
        </Box>
      </Grid>
    </Flex>

  );
}

export default Landing;
